import _ from 'lodash';
import { useApi } from '@/api';
import { useParams } from 'react-router';
import { CurrencyValue, ListItem, Flex, EmptyBox } from '@blockanalitica/ui';
import { Asset, CardList, ListSkeleton, Link } from '@/components';
import { useTheme } from 'styled-components';

type Position = {
  underlying_address: string;
  borrow: string;
  borrow_usd: string;
  price: string;
  underlying_symbol: string;
};

export default function BorrowPositionsCardList() {
  const theme = useTheme();
  const { walletAddress, network } = useParams() as {
    walletAddress: string;
    network: string;
  };
  const [data, error] = useApi<Position[]>({
    url: `/wallets/${walletAddress}/positions/borrow/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ListSkeleton />;
  }

  const rows = _.orderBy(
    data,
    [
      ({ borrow_usd }) => {
        const value = Number(borrow_usd);

        return Number.isFinite(value) ? value : Number.NEGATIVE_INFINITY;
      }
    ],
    ['desc']
  );

  return (
    <CardList title="Borrowed">
      {rows.length > 0 ? (
        rows.map((row) => (
          <ListItem
            // @ts-ignore
            as={Link}
            key={row.underlying_address}
            to={`/markets/${row.underlying_address}/wallets/${walletAddress}?tab=borrow`}
            relative="path">
            <Flex justifyContent="space-between">
              <Asset
                symbol={row.underlying_symbol}
                address={row.underlying_address}
                network={network}
                name={
                  <CurrencyValue
                    value={row.price}
                    options={{ currency: 'USD' }}
                  />
                }
                iconSize="3"
              />
              <Flex flexDirection="column" gap={['2xs', '3xs']}>
                <Flex justifyContent="flex-end">
                  <CurrencyValue
                    value={row.borrow}
                    options={{
                      currency: {
                        name: row.underlying_symbol,
                        address: row.underlying_address,
                        network: network
                      }
                    }}
                  />
                </Flex>
                <Flex justifyContent="flex-end" fontSize="-1">
                  <CurrencyValue
                    value={row.borrow_usd}
                    options={{
                      currency: 'USD'
                    }}
                    color={theme.colors.muted}
                  />
                </Flex>
              </Flex>
            </Flex>
          </ListItem>
        ))
      ) : (
        <EmptyBox message="No borrow positions" />
      )}
    </CardList>
  );
}
